import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { ProductOption } from 'src/app/assabil-kernel/models/entities/master-data/product-option-entity';
import { ProductAnalysisGroup1 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group1-entity';
import { ProductAnalysisGroup2 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group2-entity';
import { ProductAnalysisGroup3 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group3-entity';
import { ProductAnalysisGroup4 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group4-entity';
import { ProductAnalysisGroup5 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group5-entity';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { ProductProductOption } from 'src/app/assabil-kernel/models/entities/master-data/product-product-option-entity';
import { ProductLinkedProduct } from 'src/app/assabil-kernel/models/entities/master-data/product-linked-product-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { ProductPage } from 'src/app/assabil-kernel/models/entities/control-tables/product-page';
import { Brand } from 'src/app/assabil-kernel/models/entities/control-tables/brand';



@Component({
    selector: 'product-widget',
    templateUrl: './product-widget.component.html',
    styleUrls: ['./product-widget.component.scss']
})

export class ProductWidgetComponent extends BaseWidget {

    
product                 : Product         = new Product();
productOptions          : ProductOption[] = [];
productOption           : ProductOption;

linkedProduct           : Product;

@Input() productAnalysisGroup1s   : ProductAnalysisGroup1[];
@Input() productAnalysisGroup2s   : ProductAnalysisGroup2[];
@Input() productAnalysisGroup3s   : ProductAnalysisGroup3[];
@Input() productAnalysisGroup4s   : ProductAnalysisGroup4[];
@Input() productAnalysisGroup5s   : ProductAnalysisGroup5[];
@Input() productPages             : ProductPage[];
@Input() brands                   : Brand[];

productProductOptionContainer     : EntityContainer<ProductProductOption>;
productLinkedProductContainer     : EntityContainer<ProductLinkedProduct>;


productOptionsColumns  = [];
linkedProductsColumns  = [];

linkTypes = [
    { id : 1, name : 'Substitution'},
    { id : 2, name : 'Consommation'},
]


constructor(
    protected masterDataService : MasterDataService,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected controlService    : ControlTablesService,
    protected router            : Router) {
    super(toastr, leanUtilsService);
    this.productProductOptionContainer = new EntityContainer(ProductProductOption);
    this.productLinkedProductContainer = new EntityContainer(ProductLinkedProduct);

 //   this.loadControlsData();
}

ngOnInit(){
    super.ngOnInit();    
}



//------------------------------------------------------
setEntity(product: Product) {
    this.product = { ...product };
    if (product.productProductOptions != null) {
        this.product.productProductOptions  = [];
        for (let productProductOption of product.productProductOptions){
            this.product.productProductOptions.push({ ...productProductOption });
        }
    }

    if (product.productLinkedProducts != null) {
        this.product.productLinkedProducts  = [];
        for (let productLinkedProduct of product.productLinkedProducts){
            this.product.productLinkedProducts.push({ ...productLinkedProduct });
        }
    }
}
getEntity(){
    return this.product;
}
//------------------------------------------------------


//------------------------------------------------------
saveRow() : Promise<Product>{
    return this.masterDataService.productSave(this.product);
}
//------------------------------------------------------


//------------------------------------------------------
approve(){
     this.masterDataService.productApprove(this.product.productCode).then((product) => {
         this.product = product;
         this.showSuccessFulOperation();
     });
}
//------------------------------------------------------

/*
//------------------------------------------------------
loadControlsData() {
    this.productService.productOptionsGet(null, 
        this.product.productCategory.productCategoryCode, null).then(productOptions => {
        this.productOptions   = productOptions;
        
        this.setProductOptionsColumns();
    });
}


//----------------------------------------------------------------------------------------------------------------------------------------------
setProductOptionsColumns(){
    this.productOptionsColumns  = [
        { prop : 'productOption',   insertOnly : true,       name : 'Option',    key : 'productOptionCode',  lov : {    key     : "productOptionCode", 
                                                                                                                        value   : "name", 
                                                                                                                        data    : this.productOptions
                                                                                            }                 },
        { prop : 'rank',                                name : 'Rang',          type:'number'                   }
        ]
}
setLinkedProductColumns(){
this.linkedProductsColumns  = [
    { prop : 'linkedProduct.name',   insertOnly : true,      name : 'Nom',      modal :   ProductLovComponent       },
    { prop : 'linkType',                                name : 'Type',          lov :  {    key     : "id", 
                                                                                            value   : "name", 
                                                                                            data    : this.linkTypes
                                                                            }                           },
    { prop : 'rank',                                    name : 'Rang',          type:'number'                       }
    ]
}
//----------------------------------------------------------------------------------------------------------------------------------------------
*/



// Child Management Functions
//-----------------------------------------------------------------------

saveLinkedProduct(plp  : ProductLinkedProduct) {

    if (this.product.productLinkedProducts == null){
        this.product.productLinkedProducts = [];
    }
    this.product.productLinkedProducts.push(plp); 

    this.productLinkedProductContainer = new EntityContainer(ProductLinkedProduct);
}

saveProductOption(ppo  : ProductProductOption) {

    if (this.product.productProductOptions == null){
        this.product.productProductOptions = [];
    }
    this.product.productProductOptions.push(ppo); 

    this.productProductOptionContainer = new EntityContainer(ProductProductOption);
}
//-----------------------------------------------------------------------


imgLabel: string = "Choose file...";
setImage(input : HTMLInputElement) {
  let files: FileList = input.files
    this.getBase64(files[0]).then( result =>{
      this.product.photo = result;
      input.value = "";
    });
    // then the call to post method as normal...
}

getBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader(); // to read the content of the file asynchronously !
        const reader2 = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
}
